import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
  Button,
  Card,
  Divider,
  Dropdown,
  Input,
  InputNumber,
  Modal,
  Popover,
  Progress,
  Row,
  Space,
  Spin,
  Switch,
  Tag,
  Typography,
} from 'antd';
import {
  ApiOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  LineChartOutlined,
  SnippetsOutlined,
  CloseCircleOutlined,
  ArrowRightOutlined,
  ProfileOutlined,
} from '@ant-design/icons';
import { useConnection, useEvents, useUserInfo } from '../../../../connection/Application';
import Form from '../../../../form/Form';
import SelectStatus from '../../../../form/adapters/selectStatus';
import UpdatesCard from '../../../../components/molecules/updatesCard/UpdatesCard';
import {
  ProgressConfig,
  ProgressConfigInput,
  ProgressConfigType,
} from '../../../../components/molecules/ProgressConfigInput/ProgressConfigInput';
import './goal.less';
import dayjs from 'dayjs';
const { confirm } = Modal;
const { TextArea } = Input;

const { Text } = Typography;

export interface PROGRESS {
  type: ProgressConfigType;
  unit: string;
  startValue: number;
  endValue: number;
  threshold: number;
  thresholdType: string;
}

export interface KeyResultDetails {
  title: string;
  description: string;
  status?: string;
  id: number | string;
  completed: number;
  weight?: number;
  parent: any;
  progress: PROGRESS;
  currentValue: number;
}

export type Props = {
  id: number | string;
  onDelete?: (id: string | number) => void;
  onSave?: (item: any) => void;
  keyObject?: any;
  objectiveId?: number | string;
  setClose?: () => void;
  mode?: 'view' | 'edit';
  disable?: boolean;
  keyResultCount: number;
};

const KeyResult: FC<Props> = (props) => {
  const [viewDetails, setViewDetails] = useState<KeyResultDetails>({} as KeyResultDetails);
  const [viewDetails1, setViewDetails1] = useState<KeyResultDetails>({} as KeyResultDetails);
  const [mode, setMode] = useState<'view' | 'edit'>('view');
  const connection = useConnection();
  const { id } = props;
  const [form] = Form.useForm();
  const [currentTime, setCurrentTime] = useState<string>();
  const [inputNum, setInputNum] = useState<number>(0);
  const [changingStatus, setChangingStatus] = useState<string>();
  const [comment, setComment] = useState<string>();
  const [parentObjective, setParentObjective] = useState<any>();
  const [value, setValue] = useState<ProgressConfig | undefined>();
  const [popOverVisible, setPopOverVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fetching, setFetching] = useState<boolean>(false);
  const events = useEvents();

  const user = useUserInfo();
  const getCurrentTime = useCallback(() => {
    const time = dayjs().format('MMM DD, YYYY h:mm a');
    setCurrentTime(time);
  }, []);

  useEffect(() => {
    setMode(props.mode ?? 'view');
    if (typeof id === 'string') {
      let newKey: any;
      if (props.keyObject) {
        newKey = props.keyObject;
        setFetching(true);
      } else {
        newKey = {
          title: '',
          completed: 0,
          status: 'Pending',
          id: id,
          description: '',
          // type: DEFAULT_PROGRESS_CONFIG.type,
          // startValue: DEFAULT_PROGRESS_CONFIG.start,
          // endValue: DEFAULT_PROGRESS_CONFIG.end,
          // unit: DEFAULT_PROGRESS_CONFIG.unit,
          // threshold: DEFAULT_PROGRESS_CONFIG.threshold,
          // thresholdType: DEFAULT_PROGRESS_CONFIG.thresholdType,
        };
      }

      setViewDetails(newKey);
      setViewDetails1(newKey);
      form.setFieldsValue(newKey);
      // setValue(DEFAULT_PROGRESS_CONFIG);
    } else {
      setLoading(true);
      connection
        .get(`goals/keyResult/${id}`)
        .then((res) => {
          setFetching(true);
          setViewDetails(res.response);
          setViewDetails1(res.response);
          form.setFieldsValue(res.response);
          setParentObjective(res.response.parent);
          setInputNum(res.response.currentValue);
          setValue({ ...res.response.progress });
        })
        .finally(() => setLoading(false));
    }
  }, [connection, form, id, props.keyObject, props.mode]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return 'Data will be lost if you leave the page, are you sure?';
    };
    return () => {
      window.onbeforeunload = null;
    };
  });

  const menu = (
    <Button
      type="default"
      danger
      style={{ color: 'red', border: 'red 1px solid', cursor: 'pointer' }}
      onClick={() => {
        setLoading(true);
        if (typeof id !== 'string') {
          showDeleteConfirm(viewDetails.id);
        } else {
          props?.onDelete?.(id);
          // setViewDetails({} as KeyResultDetails);
          setLoading(false);
        }
      }}
      icon={<DeleteOutlined style={{ marginRight: 5 }} />}>
      Delete
    </Button>
  );

  const showDeleteConfirm = useCallback(
    (id: number | string) => {
      confirm({
        title:
          viewDetails?.parent?.keyResults?.length < 2
            ? 'Error'
            : `You are about to delete this Key Result!`,
        icon:
          viewDetails?.parent?.keyResults?.length < 2 ? (
            <CloseCircleOutlined />
          ) : (
            <ExclamationCircleOutlined style={{ color: 'red' }} />
          ),
        content:
          viewDetails?.parent?.keyResults?.length < 2
            ? `Delete Denied! You must have at least one Key Result`
            : `Are you sure delete this Key Result?`,
        okButtonProps: {
          style: { display: viewDetails?.parent?.keyResults?.length < 2 ? 'none' : 'initial' },
        },
        okText: 'Yes',
        centered: true,
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
          connection
            .delete(`goals/keyResult/${id}`)
            .then(() => {
              props?.onDelete?.(id);
              setLoading(false);
              props.setClose?.();
            })
            .catch((e) => {
              setLoading(false);
              console.log(e);
            });
        },
        onCancel() {
          setLoading(false);
          console.log('Cancel');
        },
      });
    },
    [connection, props, viewDetails?.parent?.keyResults?.length],
  );
  const saveDetails = useCallback(
    (updates: KeyResultDetails) => {
      props.onSave?.({ ...updates, id });
      const newUpdate = { ...updates };
      delete (newUpdate as any).id;
      delete newUpdate?.parent;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete newUpdate?.reusable;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete newUpdate?.goalHolder;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete newUpdate?.weight;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      delete newUpdate?.teamWeight;
      connection
        .patch(`goals/keyResult/${id}`, { keyResult: newUpdate })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => setPopOverVisible(false));
    },
    [connection, id, props],
  );

  const showErrorModal = useCallback(() => {
    confirm({
      title: 'Error',
      icon: <CloseCircleOutlined />,
      content: 'Key Result Title is missing',
      okText: 'Yes,Discard it!',
      okButtonProps: { style: { display: 'none' } },
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onCancel() {
        console.log('Cancel');
      },
    });
  }, []);

  const createKeyResult = useCallback(async () => {
    if (viewDetails?.title === '') {
      setLoading(false);
      showErrorModal();
    } else {
      // bug 2
      const type = viewDetails?.progress?.type
        ? viewDetails?.progress?.type
        : 'Start and Target Value';
      const startValue = viewDetails?.progress?.type ? viewDetails?.progress?.startValue : 0;
      const endValue = viewDetails?.progress?.type ? viewDetails?.progress?.endValue : 100;
      const unit = viewDetails?.progress?.type ? viewDetails?.progress?.unit : '%';
      const keyResult = {
        ...viewDetails,
        progress: { ...viewDetails?.progress, type, startValue, endValue, unit },
      };

      if (typeof props.objectiveId === 'number') {
        if (((keyResult as any).id + '').split('new')[1] !== undefined)
          delete (keyResult as any).id;
        if (keyResult.id) {
          delete (keyResult as any).id;
          delete (keyResult as any).parent;
          delete (keyResult as any).goalMark;
          delete (keyResult as any).goalType;
        }
        connection
          .post('goals/key-result', {
            goalId: props.objectiveId,
            keyResult,
          })
          .then((res) => {
            const key = res.response.body;
            delete key.parent;
            props.onSave?.(key);
            props.setClose?.();
          })
          .catch((e) => console.log(e));
      } else {
        setLoading(false);
        props.onSave?.(keyResult);
        props.setClose?.();
      }
    }
  }, [connection, props, showErrorModal, viewDetails]);

  const createValueChange = useCallback(() => {
    let beforeValue: number | string;
    let updatedValue: number | string;
    if (viewDetails?.progress?.type === 'Open/Done') {
      beforeValue = +(viewDetails?.completed ?? 0) === 100 ? 'Done' : 'Open';
      updatedValue = +inputNum === 100 ? 'Done' : 'Open';
    } else {
      beforeValue = viewDetails?.currentValue?.toString() ?? '0';
      updatedValue = inputNum?.toString();
    }
    const data = {
      time: dayjs().unix().toString(),
      date: dayjs().format('MMM DD, YYYY'),
      userId: user?.userId,
      type: 'keyResult',
      keyResultId: id,
      goalId: parentObjective?.id,
      beforeValue,
      updatedValue: inputNum !== undefined ? updatedValue : beforeValue,
      beforeStatus: viewDetails?.status,
      updatedStatus: changingStatus ?? viewDetails?.status,
      unit: viewDetails?.progress?.unit,
      comment: comment,
      keyResultType: viewDetails?.progress?.type,
      valueChangeType: 'History',
    };
    if (
      changingStatus !== viewDetails?.status ||
      inputNum !== viewDetails?.currentValue ||
      inputNum !== viewDetails?.completed
    ) {
      connection.post(`value-change`, { data }).catch((e) => console.log(e));
    }
  }, [
    changingStatus,
    comment,
    connection,
    id,
    inputNum,
    parentObjective?.id,
    user?.userId,
    viewDetails?.completed,
    viewDetails?.currentValue,
    viewDetails?.status,
    viewDetails?.progress?.type,
    viewDetails?.progress?.unit,
  ]);

  const content = useMemo(() => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <Space
            size={30}
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'baseline',
              marginTop: 20,
            }}>
            <Space style={{ marginBottom: 24 }}>
              <LineChartOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
              <Text type="secondary">Progress</Text>
            </Space>
            {viewDetails?.progress?.type === 'Start and Target Value' ? (
              <Space>
                <Space style={{ marginBottom: 24 }}>
                  <Typography>{viewDetails?.progress?.startValue}</Typography>
                  <ArrowRightOutlined />
                </Space>

                <InputNumber
                  defaultValue={viewDetails.currentValue}
                  style={{ width: 70, marginBottom: 24 }}
                  onChange={(e) => {
                    setInputNum(e ?? 0);
                  }}
                  min={viewDetails?.progress?.startValue}
                  max={viewDetails?.progress?.endValue}
                />

                <Space style={{ marginBottom: 24 }}>
                  <ArrowRightOutlined />
                  <Typography>{viewDetails?.progress?.endValue}</Typography>
                </Space>
              </Space>
            ) : viewDetails?.progress?.type === 'Open/Done' ? (
              <Space style={{ display: 'flex', flexDirection: 'row' }}>
                <Switch
                  size="small"
                  onChange={(val) => {
                    if (val) {
                      setInputNum(100);
                    } else {
                      setInputNum(0);
                    }
                  }}
                  checked={+(inputNum ?? 0) === 100}
                />
                <div style={{ minWidth: '90px' }}>
                  <Text>{+(inputNum ?? 0) === 100 ? 'Done' : 'Open'}</Text>
                </div>
              </Space>
            ) : (
              <Space>
                <InputNumber
                  defaultValue={viewDetails?.currentValue}
                  style={{ width: 70, marginBottom: 24 }}
                  onChange={(e) => {
                    setInputNum(e ?? 0);
                  }}
                />

                <Space style={{ marginBottom: 24 }}>
                  <ArrowRightOutlined />
                  <Typography>{viewDetails?.progress?.threshold}</Typography>
                </Space>
              </Space>
            )}
            <Tag
              style={{ height: 33, marginBottom: 24, display: 'flex', alignItems: 'center' }}
              color="">
              {currentTime}
            </Tag>
          </Space>
        </div>
        <div style={{ marginBottom: 20 }}>
          {viewDetails?.status && (
            <Space size={30}>
              <Space>
                <ProfileOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                <Text type="secondary">Status</Text>
              </Space>
              <SelectStatus
                defaultValue={viewDetails.status}
                bordered={false}
                onChange={(val) => {
                  setChangingStatus(val);
                }}
              />
            </Space>
          )}
        </div>
        <Form.Item name="comment">
          <TextArea
            placeholder="Key result status description"
            allowClear
            autoSize={{ minRows: 1, maxRows: 3 }}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Item>
        <Row style={{ justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setPopOverVisible(false)}
            type="default"
            style={{
              height: 25,
              width: 70,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 15,
              marginRight: 10,
            }}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              let completed = 0;
              if (viewDetails?.progress?.type === 'Start and Target Value') {
                completed = Math.round(
                  ((inputNum - viewDetails?.progress?.startValue) /
                    (viewDetails?.progress?.endValue - viewDetails?.progress?.startValue)) *
                    100,
                );
              } else if (viewDetails?.progress?.type === 'Threshold') {
                if (viewDetails?.progress?.thresholdType === 'Stay Above') {
                  completed = inputNum > viewDetails?.progress?.threshold ? 100 : 0;
                } else if (viewDetails?.progress?.thresholdType === 'Stay Below') {
                  completed = inputNum < viewDetails?.progress?.threshold ? 100 : 0;
                }
              } else {
                completed = inputNum ?? viewDetails.completed;
              }
              const newObj = {
                ...viewDetails,
                completed: inputNum !== undefined ? completed : viewDetails.completed,
                progress: viewDetails.progress,
                currentValue: inputNum,
                status: changingStatus ?? viewDetails?.status,
              };
              setViewDetails(newObj);
              if (typeof id !== 'string') {
                createValueChange();
                events.emit('VALUE_CHANGE_RELOAD');
                saveDetails(newObj);
              }
              setPopOverVisible(false);
            }}
            type="primary"
            style={{
              height: 25,
              width: 70,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 15,
            }}>
            Update
          </Button>
        </Row>
      </div>
    );
  }, [
    changingStatus,
    createValueChange,
    currentTime,
    events,
    id,
    inputNum,
    saveDetails,
    viewDetails,
  ]);

  return (
    <Spin spinning={loading}>
      <Form form={form}>
        <div>
          {mode === 'edit' && typeof id !== 'string' && props.keyResultCount > 1 && (
            <Space
              style={{
                marginTop: 0,
                right: 20,
                justifyContent: 'flex-end',
                display: 'flex',
                position: 'absolute',
              }}>
              <Dropdown.Button overlay={menu} trigger={['click']} />
            </Space>
          )}
          <div
            className="input-hover2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginRight: 50,
            }}>
            {mode === 'edit' && (
              <TextArea
                className="input-hover"
                value={viewDetails?.title}
                placeholder={viewDetails?.title === '' ? 'Key Result Title' : ''}
                bordered={false}
                allowClear
                onChange={(e) => {
                  setViewDetails({ ...viewDetails, title: e.target.value });
                  // if (typeof id !== 'string' && e.target.value === '')
                  //   saveDetails({ ...viewDetails, title: e.target.value });
                }}
                onBlur={() => {
                  if (
                    typeof id !== 'string' &&
                    viewDetails?.title !== viewDetails1?.title &&
                    viewDetails?.title !== ''
                  )
                    saveDetails(viewDetails);
                }}
                autoSize={{ minRows: 1, maxRows: 7 }}
              />
            )}
            {mode === 'view' && (
              <Typography
                style={{
                  fontSize: 25,
                  fontWeight: 'bold',
                  color: 'black',
                  padding: 0,
                  cursor: 'default',
                }}>
                {viewDetails?.title === '' ? 'Key Result Title' : viewDetails?.title}
              </Typography>
            )}
          </div>
          <div
            className="input-hover2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: '2%',
            }}>
            {mode === 'edit' && (
              <TextArea
                className="input-hover1"
                value={viewDetails?.description}
                allowClear
                placeholder={
                  viewDetails?.description === '' ? 'Enter the Key Result description' : ''
                }
                bordered={false}
                style={{ fontSize: 17, color: 'grey', padding: 0, marginRight: 20 }}
                onChange={(e) => {
                  setViewDetails({ ...viewDetails, description: e.target.value });
                  // if (typeof id !== 'string' && e.target.value === '')
                  //   saveDetails({ ...viewDetails, description: e.target.value });
                }}
                onBlur={() => {
                  if (
                    typeof id !== 'string' &&
                    viewDetails?.description !== viewDetails1?.description
                  )
                    saveDetails(viewDetails);
                }}
                autoSize={{ minRows: 1, maxRows: 7 }}
              />
            )}
            {mode === 'view' && (
              <Typography
                style={{
                  fontSize: 17,
                  color: 'grey',
                  padding: 0,
                  marginRight: 20,
                  cursor: 'default',
                }}>
                {viewDetails?.description === '' ? '' : viewDetails?.description}
              </Typography>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Row
              style={{
                alignItems: 'center',
              }}>
              <Space
                align={'start'}
                size={20}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '10px',
                }}>
                <Space>
                  <ApiOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                  <Text type="secondary">Value</Text>
                </Space>
                <Card
                  onClick={() => {
                    if (props.disable !== true && popOverVisible) setPopOverVisible(false);
                  }}
                  bodyStyle={{ padding: 0, margin: 0, width: '100%' }}
                  style={{
                    border: 'transparent',
                  }}>
                  <ProgressConfigInput
                    value={value}
                    mode={mode}
                    onChange={(value1) => {
                      if (viewDetails && value1) {
                        let completed = viewDetails.completed;
                        let currentValue = viewDetails?.currentValue;
                        if (viewDetails.progress?.type !== value1.type) {
                          completed = 0;
                          if (value1.type === 'Start and Target Value') {
                            currentValue = value1.startValue ?? 0;
                          } else {
                            currentValue = 0;
                          }
                        }
                        if (viewDetails.progress?.thresholdType !== value1.thresholdType) {
                          if (value1.thresholdType === 'Stay Below') {
                            completed =
                              viewDetails?.currentValue < (value1.threshold ?? 0) ? 100 : 0;
                          } else {
                            completed =
                              viewDetails?.currentValue > (value1.threshold ?? 0) ? 100 : 0;
                          }
                        }
                        const newObj = {
                          ...viewDetails,
                          progress: value1 ?? viewDetails.progress,
                          // progress: {
                          //   type: value1?.type,
                          //   startValue: value1.startValue !== undefined ? value1.startValue : 0,
                          //   endValue: value1.endValue !== undefined ? value1.endValue : 100,
                          //   unit: value1?.unit,
                          //   threshold: value1.threshold !== undefined ? value1.threshold : 0,
                          //   thresholdType: value1?.thresholdType,
                          // },
                          currentValue,
                          completed,
                        };
                        setViewDetails(newObj);
                        setValue(value1);
                        if (typeof id !== 'string') saveDetails(newObj);
                      }
                    }}
                  />
                </Card>
              </Space>
              {viewDetails.progress?.type === 'Start and Target Value' &&
                viewDetails.progress?.startValue === viewDetails.progress?.endValue && (
                  <Typography style={{ color: 'red', paddingTop: 10 }}>
                    The start and target value must not be the same.
                  </Typography>
                )}
            </Row>

            <Popover
              content={content}
              getPopupContainer={(props1) => props1?.parentNode as HTMLElement}
              trigger="click"
              open={popOverVisible}
              onOpenChange={(visible) => {
                if (visible) getCurrentTime();
              }}>
              <Card
                style={{
                  border: 'transparent',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '4%',
                }}
                bodyStyle={{ padding: 0, margin: 0, width: '100%' }}
                onClick={() => {
                  // if (
                  //   viewDetails?.progress?.startValue ||
                  //   viewDetails?.progress?.threshold ||
                  //   viewDetails?.progress?.endValue ||
                  //   viewDetails?.progress?.type === 'Open/Done'
                  // ) {
                  //   setPopOverVisible(true);
                  // } else {
                  //   message
                  //     .error({
                  //       content: 'You must enter a value first',
                  //       className: 'custom-class',
                  //       style: {
                  //         marginTop: '20vh',
                  //       },
                  //       duration: 0.5,
                  //     })
                  //     // eslint-disable-next-line @typescript-eslint/no-empty-function
                  //     .then(() => {});
                  // }
                  if (props.disable !== true) {
                    setPopOverVisible(true);
                  }
                }}>
                <Progress
                  percent={+viewDetails?.completed}
                  style={{ cursor: 'pointer', width: '80%' }}
                  strokeColor={
                    viewDetails?.status === 'Pending'
                      ? 'blue'
                      : viewDetails?.status === 'On-hold'
                      ? 'cyan'
                      : viewDetails?.status === 'Completed'
                      ? 'green'
                      : viewDetails?.status === 'Offtrack'
                      ? 'red'
                      : viewDetails?.status === 'Ontrack'
                      ? '#f4d03f'
                      : ''
                  }
                />

                {viewDetails?.status === 'Completed' ? (
                  <Tag style={{ height: 25, cursor: 'pointer', marginLeft: 20 }} color="green">
                    Completed
                  </Tag>
                ) : viewDetails?.status === 'Not Started' ? (
                  <Tag style={{ height: 25, cursor: 'pointer', marginLeft: 20 }} color="">
                    Not Started
                  </Tag>
                ) : viewDetails?.status == 'On-hold' ? (
                  <Tag style={{ height: 25, alignItems: 'center', marginLeft: 20 }} color="cyan">
                    On-hold
                  </Tag>
                ) : viewDetails?.status == 'Ontrack' ? (
                  <Tag style={{ height: 25, cursor: 'pointer', marginLeft: 20 }} color="yellow">
                    Ontrack
                  </Tag>
                ) : viewDetails?.status == 'Offtrack' ? (
                  <Tag style={{ height: 25, cursor: 'pointer', marginLeft: 20 }} color="red">
                    Offtrack
                  </Tag>
                ) : (
                  <Tag style={{ height: 25, cursor: 'pointer', marginLeft: 20 }} color="blue">
                    Pending
                  </Tag>
                )}
              </Card>
            </Popover>
          </div>
        </div>
      </Form>
      {typeof id === 'number' && (
        <div>
          <UpdatesCard
            id={id}
            type="keyResult"
            parentId={parentObjective?.id}
            disable={props.disable ?? false}
          />
        </div>
      )}
      {mode === 'edit' && typeof id === 'string' && (
        <>
          <Divider />
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {/*<div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>*/}
            {/*  {typeof id !== 'string' && (*/}
            {/*    <Button*/}
            {/*      type="default"*/}
            {/*      danger*/}
            {/*      disabled={!fetching}*/}
            {/*      loading={loading}*/}
            {/*      onClick={() => {*/}
            {/*        setLoading(true);*/}
            {/*        if (typeof id !== 'string') {*/}
            {/*          showDeleteConfirm(viewDetails.id);*/}
            {/*        } else {*/}
            {/*          props?.onDelete?.(id);*/}
            {/*          setViewDetails({} as KeyResultDetails);*/}
            {/*          setLoading(false);*/}
            {/*        }*/}
            {/*      }}*/}
            {/*      icon={<DeleteOutlined />}>*/}
            {/*      Delete*/}
            {/*    </Button>*/}
            {/*  )}*/}
            {/*</div>*/}
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="default"
                onClick={async () => {
                  setLoading(true);
                  await createKeyResult();
                }}
                disabled={
                  viewDetails?.progress?.type === 'Start and Target Value' &&
                  viewDetails?.progress.startValue === viewDetails?.progress.endValue
                }
                loading={loading}
                icon={<SnippetsOutlined />}>
                Save
              </Button>
            </div>
          </div>
        </>
      )}
    </Spin>
  );
};

export default KeyResult;
